import { useEffect } from "react";
import { Check } from "lucide-react";
import Navbar from "@/components/site/Navbar";
import Footer from "@/components/site/Footer";
import { Reveal } from "@/components/site/motion";
import DonationWidget from "@/components/site/DonationWidget";

const impact = [
  "Help fund a bed for someone who can't afford treatment",
  "Support aftercare and alumni programs that prevent relapse",
  "Fund family education and Family Care programming",
  "Provide life-skills coaching and community reintegration",
];

const DonatePage = () => {
  useEffect(() => { window.scrollTo(0, 0); }, []);
  return (
    <div data-testid="donate-page" className="bg-sand min-h-screen">
      <Navbar />
      <section className="pt-40 md:pt-48 pb-24 md:pb-32">
        <div className="mx-auto max-w-[1400px] px-5 md:px-10 grid lg:grid-cols-2 gap-14 items-center">
          <Reveal>
            <p className="text-sm uppercase tracking-[0.25em] text-terracotta mb-4">Donate</p>
            <h1 className="font-serif text-5xl md:text-7xl text-forest tracking-tight leading-[0.98]">
              Give someone a <span className="italic text-terracotta">new beginning</span>
            </h1>
            <p className="mt-6 text-lg text-ink2 leading-relaxed max-w-xl">
              Your generosity helps make recovery possible for those who need it most. Every gift directly supports
              treatment, aftercare and families on the journey to lasting recovery.
            </p>
            <div className="mt-8">
              <DonationWidget />
            </div>
          </Reveal>

          <Reveal delay={0.15}>
            <div className="rounded-3xl bg-forest text-sand p-8 md:p-12">
              <h2 className="font-serif text-3xl md:text-4xl mb-6">Where your gift goes</h2>
              <ul className="space-y-4">
                {impact.map((it, i) => (
                  <li key={i} className="flex items-start gap-3">
                    <span className="grid place-items-center w-6 h-6 rounded-full bg-sage/30 text-sand shrink-0 mt-0.5"><Check className="w-3.5 h-3.5" /></span>
                    <span className="text-sand/85">{it}</span>
                  </li>
                ))}
              </ul>
            </div>
          </Reveal>
        </div>
      </section>
      <Footer />
    </div>
  );
};

export default DonatePage;
